//Discreet hint shown while a list is being refetched
const MobileRefreshingIndicator = () => (
    <span className="text-xs flex align-items-center gap-1"
    style={{ color: "#94A3B8"}}
    role="status"
    aria-live="polite"
    >
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "0.75rem" }} aria-hidden="true" />
        A atualizar...
    </span>
)

export default MobileRefreshingIndicator;